<template>
    <w-span
        :span-class="fontClassFormatted"
        :color="color"
        v-text="description"
    ></w-span>
</template>

<script>
    import WTypographyMixin from '../../mixins/w-typography-mixin'
    import WSpan from '../WSpan'
    import WDescriptionMixin from '../../mixins/w-description-mixin'

    export default {
        name: 'WDescription',
        mixins: [WDescriptionMixin, WTypographyMixin],
        components: {
            WSpan
        },
        computed: {
            fontClassFormatted () {
                const vm = this
                const fontClass = {
                    ...vm.fontClass,
                    'py-0': vm.dense
                }
                const keys = _.filter(_.keys(fontClass), (key) => fontClass[key])

                return keys.join(' ')
            }
        }
    }
</script>
